import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { tg } from "@/constants/telegram";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";

const getInitData = (): string | undefined => {
  return tg?.initData;
};

const getAccessToken = (): string | null => {
  return localStorage.getItem("access_token");
};

// Функция для редиректа на логин при 401
// Очищаем только localStorage - Redux обновится автоматически через loadAuthFromStorage в App.tsx
const redirectToLogin = () => {
  // Проверяем, что мы не на странице логина/регистрации
  if (typeof window !== "undefined") {
    const currentPath = window.location.pathname;
    if (!currentPath.includes("/login") && !currentPath.includes("/register")) {
      // Очищаем токены при 401
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user_id");
      
      // Редиректим на логин
      // Redux store очистится автоматически при следующем рендере через loadAuthFromStorage в App.tsx
      window.location.href = "/login";
    }
  }
};

export const createBaseQuery = (baseUrl: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    credentials: "include",
    prepareHeaders: (headers) => {
      const initData = getInitData();
      if (initData) {
        headers.set("X-Telegram-Init-Data", initData);
        document.cookie = `telegram_init_data=${encodeURIComponent(initData)}; path=/; SameSite=Lax`;
      }
      
      const token = getAccessToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      
      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    
    // Обрабатываем 401 ошибку - редиректим на логин
    if (result.error) {
      const error = result.error as FetchBaseQueryError;
      if (error.status === 401 || (typeof error.status === 'number' && error.status === 401)) {
        redirectToLogin();
      }
    }
    
    return result;
  };
};
